module.exports = __webpack_public_path__ + "static/img/1_2.157ee90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/1_2.png
// module id = dDh4
// module chunks = 2